<template>
    <Card :title="$route.meta.title" dis-hover>
        <Form inline  >
            <FormItem>
            <Input v-model="query.plateNo" placeholder="车牌号/环保登记号码" clearable=""></Input>
            </FormItem>
            <FormItem>
                <RadioGroup v-model="query.emergencyRescue" type="button" @on-change="getTableData">
                    <Radio :label="null">全部</Radio>
                    <Radio :label="1">应急抢险车辆</Radio>
                </RadioGroup>
            </FormItem>
            <FormItem>
                <Button type="primary" icon="ios-search" @click="getTableData">查询</Button>
            </FormItem>
            <FormItem>

            </FormItem>
        </Form>

        <div>
            <baidu-map v-if="null!=center" :style="{width:map.width,height:map.height}" :map-style="style" class="map" ak="你的百度地图秘钥"
                       :center="center" :zoom="map.zoom"
                       @ready="handler" :scroll-wheel-zoom="true" >
                <bm-control>
                    <Input v-model="keyword" @on-change="locChange" placeholder="输入地区定位" clearable="" style="margin:5px 0 0 5px;width:180px;"></Input>
                </bm-control>
                <!--比例尺控件-->
                <bm-scale anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-scale>
                <!--缩放控件-->
                <bm-navigation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" ></bm-navigation>
                <!--聚合动态添加的点坐标-->
                <bm-marker-clusterer :averageCenter="true">
                    <bm-marker :clicking="true"  @click="showInfo(item)" v-for="item of terminal_list" :key="item.id" :icon="icons[iconIndex(item.status,item.alertStatus)]" :position="{lng: item.longitude, lat: item.latitude}">
                    </bm-marker>
                </bm-marker-clusterer>
                <bm-geolocation anchor="BMAP_ANCHOR_BOTTOM_LEFT" :showAddressBar="false" :autoLocation="true"></bm-geolocation>

                <bm-info-window :position="infoWindow.position" @close="infoClose" :title="infoWindow.title" :show="infoWindow.show" >
                    <p v-html="infoWindow.content"></p>
                </bm-info-window>

                <bm-local-search :keyword="keyword" :auto-viewport="true" :select-first-result="true" :page-capacity="5" :panel="false"
                    @markersset="markersset"></bm-local-search>
            </baidu-map>
        </div>
    </Card>
</template>
<script>
    import iTerminal from '@/module/main/api/iTerminal';
    import iProperties from '@/module/base/api/iProperties';
     import _don from '@/libs/doson'
    //百度地图
    import BaiduMap from 'vue-baidu-map/components/map/Map.vue'
    import MapView from 'vue-baidu-map/components/map/MapView.vue'
    import BmScale from 'vue-baidu-map/components/controls/Scale'
    import BmNavigation from 'vue-baidu-map/components/controls/Navigation'
    import BmGeolocation from 'vue-baidu-map/components/controls/Geolocation'
    import BmMarkerClusterer from  'vue-baidu-map/components/extra/MarkerClusterer'
    import BmMarker from 'vue-baidu-map/components/overlays/Marker'
    import BmLabel from 'vue-baidu-map/components/overlays/Label'
    import BmInfoWindow from 'vue-baidu-map/components/overlays/InfoWindow'
    import BmLocalSearch from 'vue-baidu-map/components/search/LocalSearch'
    import BmControl from 'vue-baidu-map/components/controls/Control'
    import online from '@/assets/online.png'
    import offline from '@/assets/offline.png'
    import warning from '@/assets/warning.gif'


    export default {
        name: "gps_status",
        mixins: [],
        components: {
            BaiduMap,
            MapView,
            BmScale,
            BmNavigation,
            BmMarkerClusterer,
            BmMarker,
            BmInfoWindow,
            BmGeolocation,
            BmLabel,
            BmLocalSearch,
            BmControl
        },
        data() {
            return {
                query:{
                    equipment:{
                        plateNo:null,
                        emergencyRescue:null
                    },
                    plateNo:null,
                    emergencyRescue:null,
                    terminal:{
                        status:1
                    }
                },
                markers:[],
                center:null,
                defaultCenter:null,
                map:{
                    zoom:12,
                    //width:(document.body.clientWidth-330)+'px',
                    width:'100%',
                    height:(document.body.clientHeight-230)+'px',
                },
                infoWindow:{
                    show:false,
                    position:{},
                    title:'机械信息',
                    content:null
                },
                icons:[
                    {
                        url:offline,
                        size:{width:32,height:32}
                    },
                    {
                        url:online,
                        size:{width:32,height:32}
                    },
                    {
                        url:warning,
                        size:{width:32,height:32}
                    }
                ],
                style: {
                    'featureType': 'land',
                    'elementType': 'geometry',
                    'stylers': {
                        'visibility': 'on',
                        'color': '#ffffffff'
                    }
                },
                terminal_list:[],
                mapReady:false,
                keyword:null
            }
        },
        mounted() {
            this.getTableData()
        },
        methods: {
            getTableData() {
                let _this = this;
                this.infoWindow.show = false
                iProperties.getByProp('map_center').then(res => {
                    var arr = res.value.split(',')
                    _this.center = {lng:parseFloat(arr[0]), lat:parseFloat(arr[1])}
                    _this.defaultCenter = this.center

                    _this.markers = []
                    _this.terminal_list = []
                    iTerminal.onlineAll(_this.query).then(res=>{
                        _this.terminal_list = res.map(e=>{
                            let n = e.terminal
                            e.terminal = null
                            n.equipment = e
                            n.alertStatus = e.alertStatus
                            return n
                        })
                        /*setTimeout(()=>{
                            if(_this.terminal_list.length>0){
                                let item = _this.terminal_list[0];
                                if(item.longitude && item.latitude){
                                    _this.center = {lng: item.longitude, lat: item.latitude}
                                }
                            }
                        },1000);*/
                    })
                });

            },
            infoClose(){
                this.infoWindow.show = false;
            },
            showInfo(item){
                let equipment = item.equipment;
                this.infoWindow.position = {lng: item.longitude, lat:item.latitude}
                this.infoWindow.content = '环保标号：'+equipment.epNo+'<br>所有人：'+equipment.ownerName+'<br>联系方式：'+(equipment.ownerContact||'无')+'<br>经纬度：'+(item.longitude+","+item.latitude)
                this.infoWindow.show = true;
            },
            handler(){
                this.mapReady = true
            },
            markersset(arrs) {
                arrs.length > 0 && (this.center = arrs[0].point)
            },
            locChange(e) {
                !e.data&&this.defaultCenter&&(this.center=this.defaultCenter)
            },
            iconIndex(status, warn) {
                //0 离线 1 在线 2 在低排区
                return warn ? 2 : status
            }
        },
        watch:{

        }
    }
</script>

<style scoped lang="less">

</style>
